import { Fragment } from 'react';
import styles from '../auto-insurance-matches.module.scss';

const MatchesOfferCardSkeleton = () => {
  return (
    <Fragment>
      <div className={styles.skeletonGrid}>
        {[...Array(2)].map((_, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={styles.skeletonCard}
          >
            <div className={styles.skeletonContent}>
              <div className={`${styles.skeletonItem} ${styles.title}`} />
              <div className={`${styles.skeletonItem} ${styles.subtitle}`} />
              <div className={`${styles.skeletonItem} ${styles.content}`} />
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default MatchesOfferCardSkeleton;
